const propertyPricesOptionItems = [
  {
    value: '850-1000',
    label: '$850-1000',
  },
  {
    value: '1000-1250',
    label: '$1000-1250',
  },
  {
    value: '1250-1500',
    label: '$1250-1500',
  },
  {
    value: '1500-1750',
    label: '$1500-1750',
  },
  {
    value: '1750-2000',
    label: '$1750-2000',
  },
  {
    value: '2000-2500',
    label: '$2000-2500',
  },
  {
    value: '2500-3000',
    label: '$2500-3000',
  },
  {
    value: '3000+',
    label: '$3000+',
  },
];

export default propertyPricesOptionItems;
